export const TOASTIFY_OPTIONS = {
  autoClose: 5000,
  position: "bottom-right",
  hideProgressBar: false,
  closeOnClick: true,
  pauseOnHover: true,
  draggable: true,
};
